import { createSlice } from "@reduxjs/toolkit";

interface EmployeeDetailInterface {
    certificateList: {
        activeTab?: "active" | "expired";
        currentPage?: number;
        itemsPerPage?: number;
        itemsPerPageSelect: { value: number; activeValue: boolean }[];
    };
    isLeftTagModalOpenIndex?: number;
    isRightTagModalOpenIndex?: number;
    section: {
        name: "required" | "achieved";
        value: number;
    };
}

const initialState: EmployeeDetailInterface = {
    certificateList: {
        currentPage: 1,
        itemsPerPage: 12,
        itemsPerPageSelect: [
            { value: 12, activeValue: true },
            { value: 25, activeValue: false },
            { value: 50, activeValue: false },
        ],
        activeTab: "active",
    },
    isLeftTagModalOpenIndex: -1,
    isRightTagModalOpenIndex: -1,
    section: {
        name: "required",
        value: 0,
    },
};

const EmployeeDetailSlice = createSlice({
    name: "employeeDetail",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.certificateList.currentPage = action.payload;
        },
        setActiveTab: (state, action) => {
            state.certificateList.activeTab = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.certificateList.itemsPerPage = action.payload;
            state.certificateList.itemsPerPageSelect =
                state.certificateList.itemsPerPageSelect.map((item) => ({
                    ...item,
                    activeValue: item.value === action.payload,
                }));
        },
        setIsLeftTagModalOpenIndex: (state, action) => {
            state.isLeftTagModalOpenIndex = action.payload;
        },
        setIsRightTagModalOpenIndex: (state, action) => {
            state.isRightTagModalOpenIndex = action.payload;
        },
        setSection: (state, action) => {
            state.section = action.payload;
        },
    },
});

export const employeeDetailReducer = EmployeeDetailSlice.reducer;
export const {
    setItemsPerPage,
    setCurrentPage,
    setActiveTab,
    setIsRightTagModalOpenIndex,
    setIsLeftTagModalOpenIndex,
    setSection,
} = EmployeeDetailSlice.actions;
